import emailjs from 'emailjs-com';

const handleSubmit = (templateParams) => {
  return emailjs.send('service_dhyil6o', 'template_5qgowp5', templateParams, '187DyFvWts8oCQEC_');
};

export default handleSubmit;
